export const statusColor = {
  // Ready For Billing (Blue)
  "Ready For Billing": {
    color: "#0a3985",
    backgroundColor: "#DBEAFE",
  },
  "ready for billing": {
    color: "#0a3985",
    backgroundColor: "#DBEAFE",
  },
  "READY FOR BILLING": {
    color: "#0a3985",
    backgroundColor: "#DBEAFE",
  },
  "Ready for Billing": {
    color: "#0a3985",
    backgroundColor: "#DBEAFE",
  },
  "Ready for billing": {
    color: "#0a3985",
    backgroundColor: "#DBEAFE",
  },
  "Ready For billing": {
    color: "#0a3985",
    backgroundColor: "#DBEAFE",
  },
  "ready For billing": {
    color: "#0a3985",
    backgroundColor: "#DBEAFE",
  },
  "ready For Billing": {
    color: "#0a3985",
    backgroundColor: "#DBEAFE",
  },

  // Billed (Orange)
  "Billed": {
    color: "#F59E0B",
    backgroundColor: "#FEF3C7",
  },
  "billed": {
    color: "#F59E0B",
    backgroundColor: "#FEF3C7",
  },
  "BILLED": {
    color: "#F59E0B",
    backgroundColor: "#FEF3C7",
  },

  // Processed (Purple)
  "Processed": {
    color: "#8B5CF6",
    backgroundColor: "#EDE9FE",
  },
  "processed": {
    color: "#8B5CF6",
    backgroundColor: "#EDE9FE",
  },
  "PROCESSED": {
    color: "#8B5CF6",
    backgroundColor: "#EDE9FE",
  },

  // Paid / Payment Done (Green)
  "Paid": {
    color: "#31C48D",
    backgroundColor: "#D1FAE5",
  },
  "paid": {
    color: "#31C48D",
    backgroundColor: "#D1FAE5",
  },
  "PAID": {
    color: "#31C48D",
    backgroundColor: "#D1FAE5",
  },
  "Payment Done": {
    color: "#31C48D",
    backgroundColor: "#D1FAE5",
  },
  "payment done": {
    color: "#31C48D",
    backgroundColor: "#D1FAE5",
  },
  "PAYMENT DONE": {
    color: "#31C48D",
    backgroundColor: "#D1FAE5",
  },

  // Re-assign / Re-assigned (Red)
  "Re-assign": {
    color: "#EF4444",
    backgroundColor: "#FEE2E2",
  },
  "re-assign": {
    color: "#EF4444",
    backgroundColor: "#FEE2E2",
  },
  "RE-ASSIGN": {
    color: "#EF4444",
    backgroundColor: "#FEE2E2",
  },
  "Re-assigned": {
    color: "#EF4444",
    backgroundColor: "#FEE2E2",
  },
  "re-assigned": {
    color: "#EF4444",
    backgroundColor: "#FEE2E2",
  },
  "RE-ASSIGNED": {
    color: "#EF4444",
    backgroundColor: "#FEE2E2",
  },
  "Re-Assigned": {
    color: "#EF4444",
    backgroundColor: "#FEE2E2",
  },
  "reassigned": {
    color: "#EF4444",
    backgroundColor: "#FEE2E2",
  },
  "Reassigned": {
    color: "#EF4444",
    backgroundColor: "#FEE2E2",
  },
  "REASSIGNED": {
    color: "#EF4444",
    backgroundColor: "#FEE2E2",
  },
  "re-assigned ": {
    color: "#EF4444",
    backgroundColor: "#FEE2E2",
  },
  "Re-assigned ": {
    color: "#EF4444",
    backgroundColor: "#FEE2E2",
  },

  // Batch-Created
  "Batch-Created": {
    color: "#31C48D",
    backgroundColor: "#FEE2E2",
  },
  "batch-created": {
    color: "#31C48D",
    backgroundColor: "#FEE2E2",
  },
  "BATCH-CREATED": {
    color: "#31C48D",
    backgroundColor: "#FEE2E2",
  },
};

